import {BaseFormModel} from './base-form-model';

export class OrganizationGiftCardSummary extends BaseFormModel<OrganizationGiftCardSummary> {
    organizationId: number;
    name: string;
    cardCount: number;
    initialAmount: number;
    balance: number;
}
